import React from 'react';
import { Flex, Loader, Text, Title } from '@gjensidige/builders-components';

interface Props {
  descriptionTitle: string;
  title: string;
  price: string;
  priceLabel?: string;
  period: string;
  isPriceLoading?: boolean;
}

export default function SumDetails({
  descriptionTitle,
  title,
  price,
  period,
  priceLabel,
  isPriceLoading
}: Props) {
  return (
    <div className="sum-details-wrapper">
      <Flex center="lg" layout="1" className="container-wrapper">
        <div className="sum-details">
          <div className="text-wrapper">
            <Text weight="700" size="body">
              {descriptionTitle}
            </Text>
            <div>
              <Text className="price-wrapper-title" weight="700" size="lead">
                {title}
              </Text>
            </div>
          </div>
          <div className="price-wrapper">
            {priceLabel && <Text size="small">{priceLabel}</Text>}
            <>
              {isPriceLoading ? (
                <Loader variant="ellipsis" size="md" />
              ) : (
                <div className="price-amount-section">
                  <Text className="price" weight="700" size="lead">
                    {price}
                  </Text>
                  <Text className="period" weight="700" size="body">
                    {period}
                  </Text>
                </div>
              )}
            </>
          </div>
        </div>
      </Flex>
    </div>
  );
}
